import { render, staticRenderFns } from "./formUserDetailsModal.vue?vue&type=template&id=0df79607&"
import script from "./formUserDetailsModal.vue?vue&type=script&lang=js&"
export * from "./formUserDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports